import { render } from "./BasicConfig.vue?vue&type=template&id=bf20f7ca&scoped=true"
import script from "./BasicConfig.vue?vue&type=script&lang=js"
export * from "./BasicConfig.vue?vue&type=script&lang=js"

import "./BasicConfig.vue?vue&type=style&index=0&id=bf20f7ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf20f7ca"]])

export default __exports__